export enum locationTypes {
  GET_LOCATIONS = 'GET_LOCATIONS',
  GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS',
  GET_LOCATIONS_FAILURE = 'GET_LOCATIONS_FAILURE',

  GET_SINGLE_LOCATION = 'GET_SINGLE_LOCATION',
  GET_SINGLE_LOCATION_SUCCESS = 'GET_SINGLE_LOCATION_SUCCESS',
  GET_SINGLE_LOCATION_FAILURE = 'GET_SINGLE_LOCATION_FAILURE',
}
